import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REQUEST } from ".";
import { leagueAPI, leaguepresentationsAPI, leagueTournamentsAPI, sparcRuleAPI } from "../../routes/apiEndPoints";

// fetch-league
export const fetchLeaguePages = createAsyncThunk("fetch-league", async()=>{
    try{
 const response = await API_REQUEST({
    url: leagueAPI,
    method: "GET",
  });
  return response;
    }catch (error) { }

})
// fetch-league-tournaments
export const fetchleagueTournaments = createAsyncThunk("fetch-league-tournaments", async()=>{
    try{
 const response = await API_REQUEST({
    url: leagueTournamentsAPI,
    method: "GET",
  });
  return response;
    }catch (error) { }

})
// fetch-league-presentation
export const fetchleaguePresentation = createAsyncThunk("fetch-league-presentation", async()=>{
    try{
 const response = await API_REQUEST({
    url: leaguepresentationsAPI,
    method: "GET",
  });
  return response;
    }catch (error) { }

})
// fetch-sparc-rule
export const fetchSparcRule = createAsyncThunk("fetch-sparc-rule", async()=>{
    try{
 const response = await API_REQUEST({
    url: sparcRuleAPI,
    method: "GET",
  });
  return response;
    }catch (error) { }

})